<script setup lang="ts">
    const { size = 40, color = '#fff' } = defineProps<{
        size?: number;
        color?: string;
    }>();
</script>
<template>
    <div
        class="spinner-container"
        :style="{ width: size + 'px', height: size + 'px' }"
    >
        <div class="spinner">
            <div
                v-for="i in 12"
                :key="i"
                class="spinner-segment"
                :style="{
                    transform: `rotate(${(i - 1) * 30}deg)`,
                    animationDelay: `${(i - 1) * 0.1}s`
                }"
            ></div>
        </div>
    </div>
</template>

<style scoped>
    .spinner-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .spinner {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .spinner-segment {
        position: absolute;
        top: 0;
        left: 50%;
        width: 8%;
        height: 30%;
        background-color: v-bind('color');
        border-radius: 2px;
        transform-origin: center 150%;
        animation: fade 1.2s linear infinite;
    }

    @keyframes fade {
        0%,
        100% {
            opacity: 0.15;
        }
        50% {
            opacity: 1;
        }
    }
</style>
